import Env from '~/credsystem/env';
import apiSSOCredSystem from '~/credsystem/services/apiSSOCredSystem';

interface APIResponse {
  access_token: string;
  expires_in: number;
  refresh_expires_in: number;
  token_type: string;
}

export async function getCredSystemLoginTokenUseCase(): Promise<string | null> {
  try {
    const body = {
      client_id: 'adminmarisa',
      client_secret: Env.CREDSYSTEM_SERVICE_ACCOUNT,
      grant_type: 'client_credentials',
    };

    const response = await apiSSOCredSystem.post<APIResponse>(
      `/auth/realms/marisa/protocol/openid-connect/token`,
      body
    );

    return response?.data?.access_token;
  } catch (error) {
    return null;
  }
}
